/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronsUpRight = createReactComponent(
  "chevrons-up-right",
  "IconChevronsUpRight",
  [
    ["path", { d: "M9 7h8v8", key: "svg-0" }],
    ["path", { d: "M5 11h8v8", key: "svg-1" }]
  ]
);

export { IconChevronsUpRight as default };
//# sourceMappingURL=IconChevronsUpRight.js.map
